import * as moment from 'moment';

import {WorkPoints} from '../interfaces/work-points/work-points.interface';

export function buildWorkPointsDate(workPoints: WorkPoints[]): string[] {
  return workPoints.map((item) => moment(item.data).format('DD-MM-YYYY'));
}
